import Token from './token'
import Form from './form'

export default {
  svg: 'contact',
  label: 'Update Property',
  type: 'contact',
  action: 'property',
  form: Form,
  token: Token
}
